module.exports = __webpack_public_path__ + "static/media/light_en.dddd6585.svg";